
import MenuUploadCategoryOptionTile from "../menu/menu-upload-category-option-tile.vue";
import CreateEditCategoryDialog from "../dialogs/create-edit-category-dialog.vue";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "MenuUploadCategory",
  components: {
    MenuUploadCategoryOptionTile,
    CreateEditCategoryDialog,
    ConfirmationDialog
  },
  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: [
        { id: "modify", label: "Modify" },
        { id: "delete", label: "Delete" }
      ],
      checkedCategory: {
        selectedSubcategories: [
          {
            items: []
          }
        ]
      },
      showOptionsTile: false,
      selectedCategory: {},
      selected: [],
      showCategoryDialog: false,
      showDeleteCategoryDialog: false,
      deleteLoading: false
    };
  },
  computed: {
    ...mapState("menu", ["categories"])
  },
  methods: {
    ...mapActions("menu", ["getCategories", "deleteCategory"]),
    handleOptionClick(id) {
      if (id === "modify") {
        this.handleUpdateCategory();
      } else {
        this.handleDeleteCategory();
      }
    },
    handleBtnClick() {
      this.showOptionsTile = !this.showOptionsTile;
    },
    handleUpdateCategory() {
      this.selectedCategory = this.category;
      this.showCategoryDialog = true;
    },
    handleDeleteCategory() {
      this.selectedCategory = this.category;
      this.showDeleteCategoryDialog = true;
    },
    async triggerDeleteCategory(selectedCategory) {
      this.deleteLoading = true;
      await this.getCategoryDeleted(selectedCategory);
      this.deleteLoading = false;
      this.showDeleteCategoryDialog = false;
    }
  }
};
